document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-fs-gallery]').forEach(function (gallery) {
    const slides = Array.from(gallery.querySelectorAll('[data-fs-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-fs-thumb]'));
    const thumbRail = gallery.querySelector('[data-fs-thumbs]');
    let current = 0;

    function displaySlide(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === current;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });

      thumbs.forEach(function (thumb, thumbIndex) {
        const active = thumbIndex === current;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        displaySlide(Number(thumb.dataset.index));
      });
    });

    const previous = gallery.querySelector('[data-fs-prev]');
    const next = gallery.querySelector('[data-fs-next]');
    if (previous) previous.addEventListener('click', function () { displaySlide(current - 1); });
    if (next) next.addEventListener('click', function () { displaySlide(current + 1); });

    const thumbsPrevious = gallery.querySelector('[data-fs-thumbs-prev]');
    const thumbsNext = gallery.querySelector('[data-fs-thumbs-next]');
    if (thumbsPrevious && thumbRail) {
      thumbsPrevious.addEventListener('click', function () {
        thumbRail.scrollBy({ left: -360, behavior: 'smooth' });
      });
    }
    if (thumbsNext && thumbRail) {
      thumbsNext.addEventListener('click', function () {
        thumbRail.scrollBy({ left: 360, behavior: 'smooth' });
      });
    }

    let touchStartX = null;
    gallery.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      const movement = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(movement) > 55) {
        displaySlide(movement > 0 ? current - 1 : current + 1);
      }
      touchStartX = null;
    }, { passive: true });

    const productSection = gallery.closest('[data-fs-product-section]');
    const lightbox = productSection && productSection.querySelector('[data-fs-lightbox]');
    const lightboxImage = lightbox && lightbox.querySelector('[data-fs-lightbox-image]');

    gallery.querySelectorAll('[data-fs-zoom]').forEach(function (button) {
      button.addEventListener('click', function () {
        const image = button.parentElement.querySelector('img');
        if (!lightbox || !lightboxImage || !image) return;
        lightboxImage.src = image.currentSrc || image.src;
        lightboxImage.alt = image.alt || '';
        lightbox.hidden = false;
        document.body.classList.add('fs-no-scroll');
      });
    });

    if (lightbox) {
      const closeLightbox = function () {
        lightbox.hidden = true;
        document.body.classList.remove('fs-no-scroll');
      };

      lightbox.querySelector('[data-fs-lightbox-close]').addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
        if (event.key === 'ArrowLeft') displaySlide(current - 1);
        if (event.key === 'ArrowRight') displaySlide(current + 1);
      });
    }

    displaySlide(0);
  });
});
